import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SnackbarService } from '../snackbar.service';
import { UserCategoryUpload } from '../../routes/leave-management/users-categories/users-categories.component';
import { catchError, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserCategoriesService {
  http = inject(HttpClient);
  baseUrl: string = environment.apiBaseUrl;
  messageService = inject(SnackbarService);

  uploadFile = (usersData: UserCategoryUpload[]) => {
    this.messageService.showInfo('Uploading data...');

    this.http
      .patch<{
        success: boolean;
        message: string;
      }>(`${this.baseUrl}/users/categories`, { users: usersData })
      .subscribe({
        next: () => {
          this.messageService.showSuccess(
            'User Categories Updated Successfully',
          );
        },
        error: (err) => {
          this.messageService.showError('Failed to upload...');
          console.log(err.message);
        },
      });
  };

  downloadTemplate = (): Observable<string> => {
    return this.http
      .get<{
        message: string;
        data: {
          reportURL: string;
        };
      }>(`${this.baseUrl}/users/reports/categories`)
      .pipe(
        map((res) => {
          this.messageService.showSuccess(
            'Categories Report Downloaded Successfully!',
          );
          return res.data.reportURL;
        }),
        catchError((err) => {
          this.messageService.showError('Failed to get Categories...');
          console.log(err.message);
          return ''; 
        }),
      );
  };
}
